import { AddressBase } from '../json-schemas/base/address'
import { CustomerBase } from '../json-schemas/base/customer'
import { CustomerAddressShowResponse } from '../json-schemas/serializers/customer-address-show-response'
import { httpGet, httpGetRoute, httpPost, httpPut, httpDelete } from '../utils/http.service'
import { CountriesData } from './countries.service'

function addressesPath (customerId: CustomerBase['id']) {
  if (window.currentUser.type === 'Customer') return `/${httpGetRoute()}/addresses`
  return `/${httpGetRoute()}/customers/${customerId}/addresses`
}

export async function addressesNew (): Promise<{ countries: CountriesData }> {
  return httpGet(`/${httpGetRoute()}/addresses/new`)
}

export async function addressesCreate (customerId: CustomerBase['id'], body: any): Promise<CustomerAddressShowResponse> {
  return httpPost(addressesPath(customerId), body)
}

export async function addressesUpdate (customerId: CustomerBase['id'], id: AddressBase['id'], body: any): Promise<CustomerAddressShowResponse> {
  return httpPut(`${addressesPath(customerId)}/${id}`, body)
}

export async function addressesDelete (customerId: CustomerBase['id'], id: AddressBase['id']) {
  return httpDelete(`${addressesPath(customerId)}/${id}`)
}
